/**
 * This component uses React Router v7's Link component for client-side navigation.
 */

import { Link as RouterLink } from "react-router";
import React, { forwardRef } from "react";

export const Link = forwardRef(function Link(
  props: { href: string } & Omit<React.ComponentPropsWithoutRef<"a">, "href">,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { href, ...rest } = props;

  return <RouterLink to={href} {...rest} ref={ref} />;
});
